// import { logError } from './error';

function getName(full_name){
    if(!full_name) return "";
    const full_name_array = full_name.toLowerCase().split(" ");
    return capitalizeFirstLetter(full_name_array[0]) + " " + capitalizeFirstLetter(full_name_array[full_name_array.length-1]);
}

function capitalizeFirstLetter(string) {
    return string.charAt(0).toUpperCase() + string.slice(1);
}

export default function addIntercom(Intercom, full_name, email, account_id, account_type, hide_default_launcher = true){

  const {hmac, appId} = Intercom;

  window.Intercom("boot", {
    app_id: appId || 'e5ni5di4',
    name: getName(full_name),
    email,
    user_id: account_id,
    user_hash: hmac,
    account_type,
    // custom_launcher_selector: '#intercom_component123',
    hide_default_launcher
  });
  
}